<div class="p-0 sm:p-6 pb-20 min-h-96">
  <div
    class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4"
  >
    <div>
      <h2 class="text-2xl font-bold">Mis paquetes</h2>
      <p class="text-gray-500 text-sm mt-1">
        Estos son los paquetes activos de tu compañía. Aquí puedes revisar los
        detalles y planificar tus publicaciones de empleo.
      </p>
    </div>
    <button
      class="bg-primary text-white px-4 py-2 rounded shadow hover:bg-primary/90 transition cursor-pointer"
      (click)="explorarPaquetes()"
    >
      Explorar paquetes
    </button>
  </div>
  <app-loading [text]="'Cargando paquetes'" *ngIf="isLoading"></app-loading>
  <ng-container *ngIf="!isLoading">
    <div
      *ngIf="paquetes.length > 0; else noPackage"
      class="flex flex-col space-y-4 min-h-96"
    >
      <div
        *ngFor="let pkg of paquetes"
        class="border border-gray-200 rounded-lg p-4 flex flex-col sm:flex-row sm:items-center sm:space-x-4 relative gap-3"
      >
        <div
          class="flex items-center justify-center w-12 h-12 bg-light rounded text-primary"
        >
          <ng-icon name="featherBox" size="24"></ng-icon>
        </div>
        <div class="flex-1">
          <p class="text-gray-500 text-sm">Nombre del paquete</p>
          <p class="text-lg font-bold text-black mb-3">
            {{ pkg.package.name || "Sin nombre" }}
          </p>
          <div
            class="flex flex-col sm:flex-row sm:items-center text-gray-600 text-sm sm:space-x-4 space-y-1 sm:space-y-0 mb-1"
          >
            <div class="flex items-center space-x-1">
              <ng-icon
                name="featherCalendar"
                size="16"
                class="text-primary"
              ></ng-icon>
              <span>Desde: {{ pkg.fromProperty | dateLong }}</span>
            </div>
            <div class="flex items-center space-x-1">
              <ng-icon
                name="featherCalendar"
                size="16"
                class="text-primary"
              ></ng-icon>
              <span>Hasta: {{ pkg.until | dateLong }}</span>
            </div>
          </div>
          <p class="text-primary text-sm font-semibold">
            Quedan {{ pkg.until | daysRemaining }} días para que finalice
          </p>
        </div>
        <div
          [ngClass]="{
            'bg-red-100 text-red-700': pkg.remainingPosts == '0',
            'bg-green-100 text-green-700': pkg.remainingPosts != '0'
          }"
          class="absolute top-2 right-2 px-3 py-1 rounded-full text-xs font-semibold"
        >
          <ng-container *ngIf="pkg.remainingPosts == '0'; else withPosts">
            Tope de publicaciones
          </ng-container>
          <ng-template #withPosts>
            {{ pkg.remainingPosts }} publicaciones disponibles
          </ng-template>
        </div>
      </div>
    </div>
    <ng-template #noPackage>
      <div
        class="text-center mt-6 bg-gray-50 border border-gray-200 p-6 rounded-lg"
      >
        <p class="text-gray-500 mb-2 font-semibold">
          Tu compañía actualmente no tiene paquetes activos.
        </p>
        <p class="text-gray-500 mb-4">
          Te recomendamos adquirir un paquete para poder publicar ofertas de
          empleo, maximizar postulantes y organizar tu gestión laboral de manera
          eficiente.
        </p>
        <button
          class="mt-2 bg-primary text-white px-4 py-2 rounded hover:bg-primary/90 transition"
          (click)="explorarPaquetes()"
        >
          Adquirir paquete
        </button>
      </div>
    </ng-template>
  </ng-container>
</div>
